import React, { memo } from 'react';
import { RefreshCw } from 'lucide-react';
import UIStrings from '@/Utils/UIStrings';
import { Button, Separator } from '@/Components/shadcn';

export interface BaseFilterPanelContentProps {
    resetCallback: () => void;
    children: React.JSX.Element;
}

function BaseFilterPanelContent({ resetCallback, children }: BaseFilterPanelContentProps): React.JSX.Element {
    return (
        <>
            <div className="flex flex-col">
                <div className="flex items-center gap-1.25 p-4">
                    <p className="text-foreground text-base">{UIStrings.Filter}</p>
                    <Button
                        variant="ghost"
                        className="text-primary hover:text-primary"
                        size="xs"
                        onClick={resetCallback}
                        data-cy="AdvancedFilterPanelReset"
                    >
                        <RefreshCw className="h-4 w-4" />
                        {UIStrings.ClearAll}
                    </Button>
                </div>
                <Separator className="pb-0" />
            </div>
            {children}
        </>
    );
}

export default memo(BaseFilterPanelContent);
